import script from "./OldFormDesigner.vue?vue&type=script&setup=true&lang=js"
export * from "./OldFormDesigner.vue?vue&type=script&setup=true&lang=js"

import "./OldFormDesigner.vue?vue&type=style&index=0&id=72be258c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72be258c"]])

export default __exports__